import { render, staticRenderFns } from "./SectionHeading.vue?vue&type=template&id=067f8d6a&scoped=true&"
import script from "./SectionHeading.vue?vue&type=script&lang=js&"
export * from "./SectionHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f8d6a",
  null
  
)

export default component.exports